import type { Feature, FeatureGroup, FeatureModule } from '../../types';
import { CRM_FEATURE_GROUP } from './group';
import { CRM_DASHBOARD_MODULE } from './dashboard';
import { CRM_TICKETS_MODULE } from './tickets';
import { CRM_MEMBERSHIPS_MODULE } from './memberships';
import { CRM_DONATIONS_MODULE } from './donations';
import { CRM_EVENTS_MODULE } from './events';

export { CRM_FEATURE_GROUP } from './group';
export * from './dashboard';
export * from './tickets';
export * from './memberships';
export * from './donations';
export * from './events';

export const ALL_CRM_MODULES: FeatureModule[] = [
  CRM_DASHBOARD_MODULE,
  CRM_TICKETS_MODULE,
  CRM_MEMBERSHIPS_MODULE,
  CRM_DONATIONS_MODULE,
  CRM_EVENTS_MODULE,
];

export const ALL_CRM_FEATURE_GROUPS: FeatureGroup[] = [
  CRM_FEATURE_GROUP,
  ...ALL_CRM_MODULES.flatMap((m) => m.groups),
];

export const ALL_CRM_FEATURES: Feature[] = ALL_CRM_MODULES.flatMap((m) => m.features);
